<template>
	<section id="jobs" class="section org-jobs" >

	  <div class="org-jobs-container">

      <div class="org-jobs__current-roles">
        <div class="org-jobs-header">
          <h3 class="org-jobs-title">Jobs</h3>
          <block-alert-button class="btn btn-blue-light btn-rounded btn-medium" :org_main_id="org_main_id" :org_name="org_name" v-if="!$config.white_label"></block-alert-button>
        </div>

        <template v-if="!results">
          <p class="not-hiring">This employer is not currently hiring.<br/>Sign up for an alert to find out when they are next hiring.</p>
        </template>

        <template v-else>
          <div class="job-roles">
            <button v-if="current && currentResults.length" @click="roles(true)" :class="{'is-active':showCurrentRoles}" :disabled="showCurrentRoles">Current roles</button>
            <button v-if="previous && previousResults.length" @click="roles(false)" :class="{'is-active':!showCurrentRoles}" :disabled="!showCurrentRoles">Previous roles</button>
          </div>

          <div class="job-cards">
            <template v-if="showCurrentRoles && currentResults.length" v-for="(current,c) in currentResults" :key="c">
              <block-job-card-slim :payload="current"></block-job-card-slim>
            </template>
            <template v-if="showCurrentRoles && previousResults.length" v-for="(previous,p) in previousResults" :key="p">
              <block-job-card-slim :payload="previous"></block-job-card-slim>
            </template>
          </div>

          <div class="btn-center" v-if="results">
            <!-- <template v-if="$config.white_label">
              <a class="btn btn-blue btn-medium btn-rounded" :href="see_all_link">See all</a>
            </template> -->
            <!-- <template> -->
              <button class="btn btn-blue btn-medium btn-rounded" v-if="canShowMore" @click="doLoadMore">Load more</button>
            <!-- </template> -->
          </div>
        </template>
      </div>

	  </div>
	</section>

</template>

<script>
  import AuthMixins from '@/mixins/AuthMixins';
	import algoliasearch from 'algoliasearch';

	export default {
    mixins: [AuthMixins],

		props: {
			org_main_id: {
				type: String
			},
			org_name: {
				type: String
			},
      current: {
        trpe: Boolean,
        default: true
      },
      previous: {
        trpe: Boolean,
        default: false
      }
		},

		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'listings-test' : 'listings-live',
				searchObject: {
					hitsPerPage: 50,
					facets: ["org-name"],
					facetFilters: [["option-job-search-version:public-jobs"],["org-name:"+this.org_name]] // ["published:true"]
				},
				results: false,
        currentResults: [],
        previousResults: [],
        jobsToShow: !this.$config.white_label ? 6 : 6,
        showCurrentRoles: true,
        canShowMore: true,
			}
		},

		created() {
			console.log("searchObject", this.searchObject, '"'+this.org_name+'"');

			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					// console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("jobs of organisation search raw results:", results);
					if (results.nbHits > 0) {
            this.allJobs = results.hits;
            this.results = this.allJobs.splice(0, this.jobsToShow);
            this.roles(true);
					} else {
						this.results = false;
					}
				});
		},

    methods: {
      roles(current) {
        if (this.results) {
          if (current) {
            this.currentResults = this.results.filter((el) => el.published);
          } else {
            this.previousResults = this.results.filter((el) => !el.published);
          }
        } else {
          this.currentResults = [];
          this.previousResults = [];
        }
        this.showCurrentRoles = current;
      },
      doLoadMore() {
        if (this.showCurrentRoles) {
          this.currentResults = this.currentResults.concat(this.allJobs.splice(0, this.jobsToShow));
          this.canShowMore = this.allJobs.length > 0;
        } else {
          this.previousResults = this.previousResults.concat(this.allJobs.splice(0, this.jobsToShow));
          this.canShowMore = this.allJobs.length > 0;
        }
	    }
    },

		computed: {
			see_all_link() {
				let query = 'org-name='+this.org_name;
				return '/search/jobs?q='+encodeURI(query);
			}
		}
	}
</script>
